import { MenuItem } from "@/components/shared/MenuItem";
import { formatCustomerAccountNumber } from "@/helpers/account/formatCustomer/utils";
import { formatLocalDate } from "@/utils/date";

import {
  CELL_WIDTH,
  DELEGATE_TABLE_COLUMNS,
  TID_DELEGATE_TYPE_LABEL_KEY,
} from "./constants";
import {
  FromDelegateAccountsToColumnsParams,
  FromDelegateAccountsToRowsParams,
} from "./types";

export const fromDelegateAccountsToColumns = ({
  items,
  tCompanies,
}: FromDelegateAccountsToColumnsParams) => {
  if (items.length === 0) {
    return [];
  }

  const columns = DELEGATE_TABLE_COLUMNS.map((key) => ({
    identifier: key,
    cellWidth: CELL_WIDTH[key],
    columnName: tCompanies(`companies.tid.delegate.table.columns.${key}`),
    displayedByDefault: true,
    dataTestId: `accounts__account-details-tid-delegate_${key}-column_title`,
  }));

  return [
    ...columns,
    {
      identifier: "context-menu",
      columnName: "",
      displayedByDefault: true,
      dataTestId:
        "accounts__account-details-tid-delegate_context-menu-column_title",
    },
  ];
};

export const fromDelegateAccountsToRows = ({
  items,
  tCompanies,
  locale,
  navigate,
  onDelete,
}: FromDelegateAccountsToRowsParams) =>
  items.map((item, index) => {
    const typeLabelKey = TID_DELEGATE_TYPE_LABEL_KEY[item.type];

    return {
      key: item.id,
      id: item.id,
      data: {
        companyName: (
          <span
            data-testid={`accounts__account-details-tid-delegate_companyName-${item.id}`}
          >
            {item.companyName || "-"}
          </span>
        ),
        accountNumber: (
          <span
            data-testid={`accounts__account-details-tid-delegate_accountNumber-${item.id}`}
          >
            {item.accountNumber
              ? formatCustomerAccountNumber(item.accountNumber)
              : "-"}
          </span>
        ),
        type: (
          <span
            data-testid={`accounts__account-details-tid-delegate_type-${item.id}`}
          >
            {typeLabelKey ? tCompanies(typeLabelKey) : "-"}
          </span>
        ),
        updatedTs: (
          <span
            data-testid={`accounts__account-details-tid-delegate_updatedTs-${item.id}`}
          >
            {item.updatedTs ? formatLocalDate(item.updatedTs, locale) : "-"}
          </span>
        ),
      },
      contextMenuDataTestId: `accounts__account-details-tid-delegate_${index}-context-menu`,
      menuItems: [
        {
          key: `accounts__account-details-tid-delegate_${index}-context-menu-viewAccount-button`,
          dataTestId: `accounts__account-details-tid-delegate_${index}-context-menu-viewAccount-button`,
          onClick: () => {
            if (item.linkedAccountId) {
              navigate({
                to: "/account/$id",
                params: { id: item.linkedAccountId },
              });
            }
          },
          children: (
            <MenuItem
              text={tCompanies("companies.tid.delegate.menu.viewAccount")}
            />
          ),
        },
        ...(item.type === "CUSTOM_DELEGATE"
          ? [
              {
                key: `accounts__account-details-tid-delegate_${index}-context-menu-delete-button`,
                dataTestId: `accounts__account-details-tid-delegate_${index}-context-menu-delete-button`,
                onClick: () => {
                  if (item.linkedAccountId) {
                    onDelete(item.linkedAccountId);
                  }
                },
                children: (
                  <MenuItem
                    type='danger'
                    text={tCompanies("companies.tid.delegate.actions.delete")}
                  />
                ),
              },
            ]
          : []),
      ],
    };
  });
